import { object, string, number } from 'yup';
import SignUp from '../../../components/RegisterForm/RegisterForm';
import OtpPage from '../../../components/OtpPage/OtpPage';
import { login, getOtp, confirmOtp } from '../../../common/constants/api';
import { setToken } from '../../../common/utils/auth-utils';
import { navigate } from 'gatsby';

export default [
  {
    id: 'signup',
    component: SignUp,
    initialValues: {
      //get takes 3 agrument 1st obj, 2nd keypath
      firstName: '',
      lastName: '',
      mobile: '',
      email: '',
      password: '',
      err: '',
      invitationId: '',
      hashValue: '',
      expiryTime: '',
      terms: false
    },
    validationSchema: object().shape({
      firstName: string()
        .min(1, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Please Enter First Name'),
      lastName: string()
        .min(1, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Please Enter Last Name'),
      mobile: string()
        .required('Required')
        .max(10)
        .matches(/([6-9]\d{9})/, 'Mobile should be 10 digit number'),
      email: string()
        .email('Please enter email address')
        .max(100, 'Email address is Too Long!')
        .required('Required')
        .matches(
          /^([a-z 0-9\.-_]+)@([a-z 0-9-]+).([a-z]{2,8})(.[a-z]{2,8})?$/,
          'invalid type'
        ),
      password: string()
        .min(8, 'Password must be at least 8 characters')
        .max(15, 'Password must not be longer than 15 characters')
        .required('Password is required')
        .matches(/[!@#$%^&*(),.?":{}|<>]/g, 'Must contain an Special Charecter')
    }),
    onAction: async (sectionValues, formValues) => {
      try {
        await getOtp(sectionValues);
      } catch (err) {
        throw new Error(err.response.data.message);
      }
    }
  },
  {
    id: 'otp',
    component: OtpPage,
    initialValues: {
      mobileOtp: '',
      emailOtp: ''
    },
    validationSchema: object().shape({
      mobileOtp: number()
        .typeError('Numbers only')
        .positive("A phone number can't start with a minus")
        .integer("A phone number can't include a decimal point")
        .min(4, 'Must be a 4 digit no')
        .required('An OTP is required')
    }),
    actionLabel: 'next'
  }
];
